import styles from './styles.module.scss';

const Body2 = ({ className = '', text = '', onClick = () => {} }) => (
    <span className={`${className} ${styles.body2}`} onClick={onClick}>
        {text}
    </span>
);

export default Body2;
